<MenuItem iconF7="gear_alt_fill" iconOnly {iconSize} dropdown on:menuOpened={buildDropdown}>
  <MenuDropdown left>
    <div class="cards-editor-config-dropdown">
      <List noHairlinesMd>
        {#each options as option (option.key)}
          <CardsEditorConfigListItem {option} value={getConfigValue(option.key)} on:change={(e) => handleOptionChange(option.key, e)} />
        {/each}
      </List>
    </div>
  </MenuDropdown>
</MenuItem>

<style>
  *, *::before, *::after {
    box-sizing: border-box;
  }

  .cards-editor-config-dropdown {
    white-space: nowrap;
    width: 50vw;
  }</style>

<script lang="ts">import { MenuItem, MenuDropdown, List } from 'framework7-svelte';
import './CardsEditorComponentInterfaces';
import { CardsPageContextKey } from './context';
import { getContext } from 'svelte';
import CardsEditorConfigListItem from './CardsEditorConfigListItem.svelte';
export let iconSize = 20;
const pageContext = getContext(CardsPageContextKey);
const selectedComponentStore = pageContext.editorModeManager.getSelectedComponentStore();
$: selectedComponent = $selectedComponentStore;
let options = [];
function buildDropdown() {
    var _a;
    options = ((_a = selectedComponent === null || selectedComponent === void 0 ? void 0 : selectedComponent.configSpec) === null || _a === void 0 ? void 0 : _a.options) || [];
}
function getConfigValue(key) {
    return selectedComponent === null || selectedComponent === void 0 ? void 0 : selectedComponent.getConfigValue(key);
}
function handleOptionChange(key, e) {
    //console.log("HANDLE OPTION CHANGE", key, e);
    if (selectedComponent && e.detail) {
        selectedComponent.setConfigValue(key, e.detail.value);
    }
}
</script>
